var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapAutocomplete',{attrs:{"value":_vm.currentPlace.formatted_address,"id":"mapComplete","componentRestrictions":{ country: 'EE' },"selectFirstOnEnter":true,"placeholder":"Address, maja, korter"},on:{"place_changed":_vm.setPlace}})}
var staticRenderFns = []

export { render, staticRenderFns }